import { createSlice } from "@reduxjs/toolkit";

const initialNotice = {
  definition: "",
  explanation: ""
};

const initialNoticesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  notice: initialNotice
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherNoticeSlice = createSlice({
  name: "teacherNotices",
  initialState: initialNoticesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getFilterList
    filterListFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.filterList = entities;
    },
    //getNoticeDetail
    noticeFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.notice = entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanListState
    listStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    },
    //cleanTeacherNoticesState
    teacherNoticesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.filterList = [];
      state.totalCount = 0;
      state.notice = initialNotice;
    }
  }
});